import {ApiResult} from "../ApiResult";

export class RemoveAccountReason {
 public reasonId: number;
 public reasonText: string;
 public showCustomInput: boolean;
 constructor(data: any) {
   this.reasonId = data.reasonId;
   this.reasonText = data.reasonText;
   this.showCustomInput = data.showCustomInput;
 }
}
export class RemoveAccountReasonResult extends ApiResult {
  public reasons: RemoveAccountReason[] | null;
  constructor(data: any) {
    super(data);
    this.reasons = data.resultData.map((i: any) => new RemoveAccountReason(i));
  }
}
